<div class="sign-up-header">
  <div>
    <h1 class="sign-up-header__heading">{{ heading }}</h1>
    <div *ngIf="description" class="sign-up-header__description">{{ description }}</div>
    <h2 *ngIf="subHeading" class="sign-up-header__sub-heading">
      {{ subHeading }}
    </h2>
  </div>
</div>
